import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';
import { put } from 'redux-saga/effects';
import { history } from '../../utils';
import { actions as profileActions } from './profile';
import { actions as sessionActions } from './session';
import { setToken } from './token';

const key = 'AUTH/LOGOUT';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchLogout(client, { payload: { noRequest } }) {
  try {
    const response = !noRequest
      ? yield client.post('/user/auth/logout')
      : { result: null };
    yield put(actions.loadSuccess(response.result));

    yield put(profileActions.resetCache());
    yield put(sessionActions.resetCache());
    yield put(setToken(null, false));

    localStorage.clear()
    window.location.href = '/';
    // yield put(profileActions.loadSuccess({}));
    // yield put(sessionActions.loadSuccess({}));
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
